import { render, staticRenderFns } from "./estate-docs.vue?vue&type=template&id=e0d467cc&scoped=true&"
import script from "./estate-docs.vue?vue&type=script&lang=js&"
export * from "./estate-docs.vue?vue&type=script&lang=js&"
import style0 from "./estate-docs.vue?vue&type=style&index=0&id=e0d467cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d467cc",
  null
  
)

export default component.exports